import {
    CREATE_ACCESSORIES_USAGE_REQUEST,
    CREATE_ACCESSORIES_USAGE_SUCCESS,
    CREATE_ACCESSORIES_USAGE_FAILURE,
    DELETE_ACCESSORIES_USAGE_REQUEST,
    DELETE_ACCESSORIES_USAGE_SUCCESS,
    DELETE_ACCESSORIES_USAGE_FAILURE,
    FETCH_SINGLE_ACCESSORIES_USAGE_REQUEST,
    FETCH_SINGLE_ACCESSORIES_USAGE_SUCCESS,
    FETCH_SINGLE_ACCESSORIES_USAGE_FAILURE,
    FETCH_ACCESSORIES_USAGE_REQUEST,
    FETCH_ACCESSORIES_USAGE_SUCCESS,
    FETCH_ACCESSORIES_USAGE_FAILURE,
    UPDATE_ACCESSORIES_USAGE_REQUEST,
    UPDATE_ACCESSORIES_USAGE_SUCCESS,
    UPDATE_ACCESSORIES_USAGE_FAILURE,
    RESET_ACCESSORIES_USAGE_INFO,
    CREATE_ACCESSORIES_USAGE_FORM,
    UPDATE_ACCESSORIES_USAGE_FORM
} from './accessoriesUsage.actionsType';

export const ACCESSORIES_USAGE = 'accessoriesUsage';

let initialState = {
    loading: false,
    accessoriesUsageList: [],
    accessoriesUsageform: {
        fldUsagetypeQuanity: false,
        fldUsagetypePerval: false,
        fldUsagetypeNR: false,
        fldExcessTypePerval: false,
        fldExcessTypeUnit: false
    },
    selectedState: {},
    errorMessage: ''
};

export let accessoriesUsageReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_ACCESSORIES_USAGE_REQUEST:
        case CREATE_ACCESSORIES_USAGE_REQUEST:
        case UPDATE_ACCESSORIES_USAGE_REQUEST:
        case FETCH_SINGLE_ACCESSORIES_USAGE_REQUEST:
        case DELETE_ACCESSORIES_USAGE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_ACCESSORIES_USAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesUsageList: updatePayload
            };
        case CREATE_ACCESSORIES_USAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesUsageform: {}
            };
        case UPDATE_ACCESSORIES_USAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesUsageform: {}
            };
        case FETCH_SINGLE_ACCESSORIES_USAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesUsageform: payload
            };
        case DELETE_ACCESSORIES_USAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesUsageform: {}
            };
        case RESET_ACCESSORIES_USAGE_INFO:
            return {
                ...state,
                accessoriesUsageform: {}
            };
        case CREATE_ACCESSORIES_USAGE_FORM:
        case UPDATE_ACCESSORIES_USAGE_FORM:
            return {
                ...state,
                loading: false,
                accessoriesUsageform: {
                    ...state.accessoriesUsageform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_ACCESSORIES_USAGE_FAILURE:
        case CREATE_ACCESSORIES_USAGE_FAILURE:
        case UPDATE_ACCESSORIES_USAGE_FAILURE:
        case FETCH_SINGLE_ACCESSORIES_USAGE_FAILURE:
        case DELETE_ACCESSORIES_USAGE_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
